(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ambient-scene-layer"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-ambient-scene]');
    if (!root) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const canvas = root.querySelector('.ambient-scene__canvas');
    if (!canvas) return;

    let rafId = 0;
    let resizeObserver;

    const loadThree = (moduleUrl) => {
      if (window.THREE) return Promise.resolve(window.THREE);
      if (window.__threeLoadPromise) return window.__threeLoadPromise;

      const sourceUrl = moduleUrl || '/assets/three.module.min.js';

      window.__threeLoadPromise = new Promise((resolve, reject) => {
        import(sourceUrl)
          .then((module) => {
            if (module && module.Scene) {
              resolve(module);
              return;
            }

            if (module && module.default && module.default.Scene) {
              resolve(module.default);
              return;
            }

            throw new Error('Invalid Three.js module export');
          })
          .catch(() => {
            reject(new Error('Unable to load local Three.js module'));
          });
      });

      return window.__threeLoadPromise;
    };

    const init = async () => {
      try {
        const THREE = await loadThree(root.dataset.threeModuleUrl);
        const preset = root.dataset.ambientPreset || 'home';

        const scene = new THREE.Scene();
        const camera = new THREE.PerspectiveCamera(42, 1, 0.1, 180);
        camera.position.set(0, 0, 20);

        const renderer = new THREE.WebGLRenderer({
          canvas,
          alpha: true,
          antialias: false,
          powerPreference: 'low-power'
        });

        if (!renderer.getContext()) {
          renderer.dispose();
          return;
        }

        const isMobile = window.matchMedia('(max-width: 768px)').matches;
        renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, isMobile ? 1.1 : 1.3));
        renderer.setClearColor(0x000000, 0);
        renderer.outputColorSpace = THREE.SRGBColorSpace;

        const objects = [];

        let accent = 0xff8a40;
        let glow = 0x9fd3ff;
        if (preset === 'about') {
          accent = 0xb87a4e;
          glow = 0x6db7ff;
        } else if (preset === 'blog') {
          accent = 0x7f97b1;
          glow = 0xb6cbdf;
        }

        scene.add(new THREE.AmbientLight(glow, preset === 'blog' ? 0.25 : 0.32));
        const edgeLight = new THREE.PointLight(accent, 0.45, 40, 2);
        edgeLight.position.set(-3.5, 2.5, 9);
        scene.add(edgeLight);

        const fillLight = new THREE.PointLight(glow, 0.28, 34, 2);
        fillLight.position.set(3.4, -2.2, 7.2);
        scene.add(fillLight);

        const rootGroup = new THREE.Group();
        scene.add(rootGroup);

        const gemMaterial = new THREE.MeshPhysicalMaterial({
          color: accent,
          roughness: 0.1,
          metalness: 0.05,
          transmission: preset === 'blog' ? 0.34 : 0.55,
          thickness: 0.7,
          clearcoat: 1,
          clearcoatRoughness: 0.15,
          transparent: true,
          opacity: preset === 'blog' ? 0.22 : 0.32,
          emissive: accent,
          emissiveIntensity: preset === 'blog' ? 0.03 : 0.06
        });

        const metalMaterial = new THREE.MeshStandardMaterial({
          color: preset === 'blog' ? 0x8896a4 : 0x7a624d,
          roughness: 0.28,
          metalness: 0.82,
          transparent: true,
          opacity: preset === 'blog' ? 0.18 : 0.28
        });
        const wireMaterial = new THREE.MeshBasicMaterial({
          color: glow,
          transparent: true,
          opacity: preset === 'blog' ? 0.32 : 0.42,
          wireframe: true
        });

        const createDie = (geometry, x, y, z, scale, spin, style) => {
          const group = new THREE.Group();
          const solid = new THREE.Mesh(geometry, style === 'metal' ? metalMaterial : gemMaterial);
          const wire = new THREE.Mesh(geometry, wireMaterial);
          const wireBold = new THREE.Mesh(geometry, wireMaterial);
          wireBold.scale.setScalar(1.02);
          group.add(solid);
          group.add(wire);
          group.add(wireBold);
          group.position.set(x, y, z);
          group.scale.setScalar(scale);
          rootGroup.add(group);
          objects.push({ mesh: group, spin, baseY: y, phase: Math.random() * Math.PI * 2 });
        };

        createDie(new THREE.DodecahedronGeometry(1), -8.6, 3.1, -7.6, 0.58, 0.0013, 'gem');
        createDie(new THREE.IcosahedronGeometry(1), 8.8, -1.2, -8.2, 0.62, -0.0011, 'metal');
        createDie(new THREE.OctahedronGeometry(1), 5.1, 3.9, -9.2, 0.44, 0.0012, 'gem');
        createDie(new THREE.CylinderGeometry(0.72, 0.72, 1.2, 10), -5.4, -3.7, -8.8, 0.46, -0.0009, 'metal');

        const desktopLayouts = [
          { x: -10.8, y: 2.8, z: -7.6, s: 0.52 },
          { x: 10.9, y: -1.0, z: -8.2, s: 0.56 },
          { x: 9.7, y: 4.1, z: -9.2, s: 0.4 },
          { x: -10.1, y: -3.4, z: -8.8, s: 0.42 }
        ];

        const mobileLayouts = [
          { x: -5.6, y: 2.7, z: -7.2, s: 0.4 },
          { x: 5.8, y: -0.7, z: -7.8, s: 0.42 },
          { x: 5.3, y: 3.3, z: -8.9, s: 0.32 },
          { x: -5.2, y: -3.0, z: -8.3, s: 0.34 }
        ];

        const applyLayout = () => {
          const mobileView = window.matchMedia('(max-width: 768px)').matches;
          const layout = mobileView ? mobileLayouts : desktopLayouts;

          objects.forEach((obj, index) => {
            const target = layout[index];
            if (!target) return;
            obj.mesh.position.set(target.x, target.y, target.z);
            obj.mesh.scale.setScalar(target.s);
            obj.baseY = target.y;
          });
        };

        const particleCount = isMobile ? 70 : 120;
        const emberPositions = new Float32Array(particleCount * 3);
        const emberSpeeds = new Float32Array(particleCount);

        for (let i = 0; i < particleCount; i += 1) {
          const i3 = i * 3;
          emberPositions[i3] = (Math.random() - 0.5) * 30;
          emberPositions[i3 + 1] = (Math.random() * 12) - 7;
          emberPositions[i3 + 2] = (Math.random() - 0.5) * 16;
          emberSpeeds[i] = 0.002 + Math.random() * 0.005;
        }

        const emberGeometry = new THREE.BufferGeometry();
        emberGeometry.setAttribute('position', new THREE.BufferAttribute(emberPositions, 3));
        const emberMaterial = new THREE.PointsMaterial({
          color: glow,
          size: 0.08,
          transparent: true,
          opacity: preset === 'blog' ? 0.16 : 0.24,
          depthWrite: false,
          blending: THREE.AdditiveBlending
        });
        const embers = new THREE.Points(emberGeometry, emberMaterial);
        rootGroup.add(embers);

        let width = 0;
        let height = 0;

        const resize = () => {
          width = window.innerWidth;
          height = window.innerHeight;
          renderer.setSize(width, height, false);
          camera.aspect = width / height;
          camera.position.z = width < 768 ? 18.5 : 20;
          camera.updateProjectionMatrix();
          applyLayout();
        };

        resize();
        resizeObserver = new ResizeObserver(resize);
        resizeObserver.observe(document.documentElement);
        root.classList.add('is-ready');

        let t = 0;
        const animate = () => {
          t += 0.006;

          objects.forEach((obj, index) => {
            obj.mesh.rotation.x += obj.spin * 1.15;
            obj.mesh.rotation.y -= obj.spin * 0.92;
            obj.mesh.position.y = obj.baseY + Math.sin(t * (0.7 + index * 0.21) + obj.phase) * 0.22;
          });

          const pos = emberGeometry.attributes.position.array;
          for (let i = 0; i < particleCount; i += 1) {
            const i3 = i * 3;
            pos[i3 + 1] += emberSpeeds[i];
            if (pos[i3 + 1] > 6.2) {
              pos[i3 + 1] = -7;
            }
          }
          emberGeometry.attributes.position.needsUpdate = true;

          edgeLight.intensity = 0.42 + Math.sin(t * 4.4) * 0.06;

          renderer.render(scene, camera);

          rafId = window.requestAnimationFrame(animate);
        };

        animate();

        const cleanup = () => {
          if (rafId) window.cancelAnimationFrame(rafId);
          if (resizeObserver) resizeObserver.disconnect();

          emberGeometry.dispose();
          emberMaterial.dispose();
          objects.forEach((obj) => {
            obj.mesh.children.forEach((child) => {
              child.geometry.dispose();
            });
          });
          gemMaterial.dispose();
          metalMaterial.dispose();
          wireMaterial.dispose();
          renderer.dispose();
        };

        window.addEventListener('pagehide', cleanup, { once: true });
      } catch (error) {
      }
    };

    init();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cookie-banner"] && !Shopify.designMode) return;
  try {
    function initCookieBanner() {
    const banner = document.getElementById('CookieBanner');
    const acceptBtn = document.getElementById('AcceptCookies');
    
    if (!banner || !acceptBtn) return;

    const cookieName = 'scenery_en_zo_cookies_accepted';
    
    if (!localStorage.getItem(cookieName)) {
      banner.removeAttribute('hidden');
      // Small delay to trigger transition
      setTimeout(() => banner.classList.add('is-visible'), 100);
    }

    acceptBtn.addEventListener('click', () => {
      localStorage.setItem(cookieName, 'true');
      banner.classList.remove('is-visible');
      setTimeout(() => banner.setAttribute('hidden', ''), 500);
    });
  }

  document.addEventListener('DOMContentLoaded', initCookieBanner);
  document.addEventListener('shopify:section:load', initCookieBanner);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["featured-slider"] && !Shopify.designMode) return;
  try {
    (function () {
    function initSlider(section) {
      if (!section || section.dataset.sliderInitialized === 'true') return;
      var track = section.querySelector('[data-slider-track]');
      var prevBtn = section.querySelector('[data-slider-prev]');
      var nextBtn = section.querySelector('[data-slider-next]');
      if (!track || !prevBtn || !nextBtn) return;
      section.dataset.sliderInitialized = 'true';

      // Touch/compact viewports scroll natively; hide the arrows and bail.
      if (window.matchMedia('(max-width: 992px)').matches) {
        prevBtn.style.display = 'none';
        nextBtn.style.display = 'none';
        return;
      }

      var snapRaf = null;

      function getScrollAmount() {
        var item = track.querySelector('.featured-slider__item');
        var gap = parseInt(window.getComputedStyle(track).gap) || 0;
        return item ? item.offsetWidth + gap : track.offsetWidth;
      }

      function getSnapTarget(fromScroll, toScroll) {
        var step = getScrollAmount();
        if (!step) return toScroll;
        var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        var baseIndex = Math.round(fromScroll / step);
        var delta = toScroll - fromScroll;
        var indexShift = 0;
        if (delta > 0) indexShift = Math.max(1, Math.round(delta / step));
        else if (delta < 0) indexShift = Math.min(-1, Math.round(delta / step));
        var targetIndex = Math.max(0, baseIndex + indexShift);
        return Math.max(0, Math.min(targetIndex * step, maxScroll));
      }

      function animateSnapTo(target) {
        var start = track.scrollLeft;
        var diff = target - start;
        if (Math.abs(diff) < 1) {
          track.scrollLeft = Math.round(target);
          track.classList.remove('is-dragging');
          snapRaf = null;
          return;
        }
        var duration = 220;
        var startTime = performance.now();
        var tick = function (now) {
          var progress = Math.min((now - startTime) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          track.scrollLeft = start + diff * eased;
          if (progress < 1) {
            snapRaf = requestAnimationFrame(tick);
          } else {
            track.scrollLeft = Math.round(target);
            track.classList.remove('is-dragging');
            snapRaf = null;
          }
        };
        snapRaf = requestAnimationFrame(tick);
      }

      var interactiveSelector = 'button, input, select, textarea, label, .badge';
      var pointerDown = false, isDragging = false, suppressClick = false;
      var releaseTimer = null, startX = 0, startScrollLeft = 0, dragDistance = 0;
      var dragThreshold = 8;

      track.querySelectorAll('img, a').forEach(function (el) { el.setAttribute('draggable', 'false'); });

      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        if (e.target.closest(interactiveSelector)) return;
        if (releaseTimer) { clearTimeout(releaseTimer); releaseTimer = null; }
        if (snapRaf) { cancelAnimationFrame(snapRaf); snapRaf = null; }
        pointerDown = true;
        isDragging = false;
        dragDistance = 0;
        startX = e.clientX;
        startScrollLeft = track.scrollLeft;
        track.classList.add('is-dragging');
      });

      track.addEventListener('pointermove', function (e) {
        if (!pointerDown) return;
        var deltaX = e.clientX - startX;
        dragDistance = Math.abs(deltaX);
        if (!isDragging && Math.abs(deltaX) > dragThreshold) isDragging = true;
        if (!isDragging) return;
        track.scrollLeft = startScrollLeft - deltaX;
        e.preventDefault();
      });

      function endDrag() {
        if (!pointerDown) return;
        pointerDown = false;
        if (isDragging) {
          suppressClick = dragDistance > dragThreshold;
          animateSnapTo(getSnapTarget(startScrollLeft, track.scrollLeft));
          releaseTimer = setTimeout(function () { suppressClick = false; releaseTimer = null; }, 220);
        } else {
          track.classList.remove('is-dragging');
        }
        isDragging = false;
      }

      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') endDrag(); });

      track.addEventListener('click', function (e) {
        if (!suppressClick) return;
        e.preventDefault();
        e.stopPropagation();
      }, true);

      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });

      function toggleButtons() {
        var atStart = track.scrollLeft <= 10;
        var atEnd = Math.ceil(track.scrollLeft + track.offsetWidth) >= track.scrollWidth - 10;
        prevBtn.style.opacity = atStart ? '0' : '1';
        prevBtn.style.pointerEvents = atStart ? 'none' : 'auto';
        nextBtn.style.opacity = atEnd ? '0' : '1';
        nextBtn.style.pointerEvents = atEnd ? 'none' : 'auto';
      }
      track.addEventListener('scroll', toggleButtons, { passive: true });
      window.addEventListener('resize', toggleButtons, { passive: true });
      setTimeout(toggleButtons, 500);
    }

    function lazyInit(section) {
      if (!section) return;
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries, observer) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            initSlider(section);
            observer.disconnect();
          });
        }, { rootMargin: '200px 0px' });
        io.observe(section);
      } else {
        initSlider(section);
      }
    }

    function boot() {
      document.querySelectorAll('[data-slider-track]').forEach(function (track) {
        var section = track.closest('[data-section-id]') || track.parentElement;
        if (section) lazyInit(section);
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["games-character-creator"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-games-cc]');
    if (!root) return;
    let i18n = {};
    try { i18n = JSON.parse(root.querySelector('[data-cc-i18n]').textContent); } catch (e) { i18n = {}; }
    const urls = {
      three: root.dataset.threeUrl,
      cannon: root.dataset.cannonUrl,
      textures: root.dataset.texturesUrl,
      dice: root.dataset.diceUrl,
      catalog: root.dataset.catalogUrl,
      srdIndex: root.dataset.srdIndexUrl,
      // data-srd-2014-url does not camel-case (digit after the hyphen), so read the attributes directly
      srd: { 'srd-2014': root.getAttribute('data-srd-2014-url'), 'srd-2024': root.getAttribute('data-srd-2024-url') },
    };
    import(root.dataset.appUrl)
      .then((m) => m.mount({ root, urls, i18n }))
      .catch((err) => {
        const build = root.querySelector('[data-cc-build]');
        if (build) build.textContent = (i18n.load_failed || 'The character creator could not start.') + ' ' + (err && err.message ? err.message : '');
        const loading = root.querySelector('[data-cc-loading]');
        if (loading) loading.hidden = true;
      });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["games-dice-roller"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-games-dice]');
    if (!root) return;

    const canvas = root.querySelector('.games-dice__canvas');
    const loading = root.querySelector('[data-loading]');
    const fallback = root.querySelector('[data-fallback]');
    const resultBox = root.querySelector('[data-result]');
    const totalEl = root.querySelector('[data-total]');
    const breakdownEl = root.querySelector('[data-breakdown]');
    const summaryEl = root.querySelector('[data-summary]');
    const rollBtn = root.querySelector('[data-roll]');
    const rollLabel = root.querySelector('[data-roll-label]');
    const modInput = root.querySelector('[data-modifier]');
    const modeSel = root.querySelector('[data-mode]');
    const historyList = root.querySelector('[data-history]');
    const historyEmpty = root.querySelector('[data-history-empty]');
    const toast = root.querySelector('[data-toast]');
    const trayColorsBox = root.querySelector('[data-tray-colors]');
    const rows = Array.from(root.querySelectorAll('.games-dice__row'));

    let I18N = {};
    try { I18N = JSON.parse(root.querySelector('[data-games-i18n]').textContent); } catch (e) { I18N = {}; }
    const t = (key, fallbackText) => I18N[key] || fallbackText;
    const STORE_KEY = 'sez-games-dice-v1';
    const HISTORY_KEY = 'sez-games-dice-history-v1';

    const loadThree = (url) => {
      if (window.THREE) return Promise.resolve(window.THREE);
      if (window.__threeLoadPromise) return window.__threeLoadPromise;
      window.__threeLoadPromise = import(url).then((m) => (m && m.Scene ? m : m.default));
      return window.__threeLoadPromise;
    };

    let TEX = null;
    let engine = null;
    let rolling = false;

    const showToast = (msg) => {
      toast.textContent = msg;
      toast.classList.add('is-on');
      clearTimeout(showToast.tid);
      showToast.tid = setTimeout(() => toast.classList.remove('is-on'), 2200);
    };

    /* ----- persist the sheet ----- */
    const readState = () => {
      try { return JSON.parse(localStorage.getItem(STORE_KEY) || '{}'); } catch (e) { return {}; }
    };
    const writeState = () => {
      const s = { dice: {}, modifier: Number(modInput.value) || 0, mode: modeSel.value, tray: root.dataset.tray || '' };
      rows.forEach((r) => { s.dice[r.dataset.die] = { count: Number(r.querySelector('[data-count]').value) || 0, color: r.dataset.color }; });
      try { localStorage.setItem(STORE_KEY, JSON.stringify(s)); } catch (e) { /* private mode */ }
    };

    const buildSwatches = (colors) => {
      rows.forEach((row) => {
        const box = row.querySelector('[data-swatches]');
        box.innerHTML = '';
        colors.forEach((c) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'games-swatch';
          b.style.background = `radial-gradient(circle at 35% 30%, ${lighten(c.hex)}, ${c.hex})`;
          b.title = c.label;
          b.setAttribute('aria-label', c.label);
          b.setAttribute('aria-pressed', String(row.dataset.color === c.key));
          b.addEventListener('click', () => {
            row.dataset.color = c.key;
            box.querySelectorAll('.games-swatch').forEach((s) => s.setAttribute('aria-pressed', 'false'));
            b.setAttribute('aria-pressed', 'true');
            writeState();
          });
          box.appendChild(b);
        });
      });
    };
    const lighten = (hex) => {
      const n = parseInt(hex.slice(1), 16);
      const r = Math.min(255, (n >> 16) + 60);
      const g = Math.min(255, ((n >> 8) & 255) + 60);
      const b = Math.min(255, (n & 255) + 60);
      return `rgb(${r},${g},${b})`;
    };

    const updateRowState = () => {
      rows.forEach((r) => {
        const n = Number(r.querySelector('[data-count]').value) || 0;
        r.classList.toggle('is-active', n > 0);
      });
      const total = rows.reduce((a, r) => a + (Number(r.querySelector('[data-count]').value) || 0), 0);
      rollBtn.disabled = total === 0 && !rolling;
    };

    rows.forEach((row) => {
      const input = row.querySelector('[data-count]');
      row.querySelectorAll('[data-step]').forEach((b) => {
        b.addEventListener('click', () => {
          input.value = Math.max(0, Math.min(20, (Number(input.value) || 0) + Number(b.dataset.step)));
          updateRowState();
          writeState();
        });
      });
      input.addEventListener('change', () => {
        input.value = Math.max(0, Math.min(20, Number(input.value) || 0));
        updateRowState();
        writeState();
      });
    });
    root.querySelectorAll('[data-mod]').forEach((b) => {
      b.addEventListener('click', () => {
        modInput.value = Math.max(-50, Math.min(50, (Number(modInput.value) || 0) + Number(b.dataset.mod)));
        writeState();
      });
    });
    modInput.addEventListener('change', writeState);
    modeSel.addEventListener('change', writeState);

    root.querySelectorAll('[data-preset]').forEach((b) => {
      b.addEventListener('click', () => {
        rows.forEach((r) => { r.querySelector('[data-count]').value = 0; });
        if (b.dataset.preset !== 'clear') {
          b.dataset.preset.split(',').forEach((part) => {
            const [sides, count] = part.split(':');
            const row = rows.find((r) => r.dataset.die === sides);
            if (row) row.querySelector('[data-count]').value = count;
          });
        }
        updateRowState();
        writeState();
        if (b.dataset.preset !== 'clear') doRoll();
        else if (engine) { engine.clear(); resultBox.hidden = true; summaryEl.textContent = ''; }
      });
    });

    /* ----- history ----- */
    const readHistory = () => { try { return JSON.parse(localStorage.getItem(HISTORY_KEY) || '[]'); } catch (e) { return []; } };
    const renderHistory = () => {
      const items = readHistory();
      historyList.innerHTML = '';
      historyEmpty.hidden = items.length > 0;
      items.forEach((it) => {
        const li = document.createElement('li');
        const time = new Date(it.at);
        const total = document.createElement('b');
        total.textContent = String(it.total);
        const text = document.createElement('span');
        text.textContent = it.text;
        const when = document.createElement('time');
        when.dateTime = time.toISOString();
        when.textContent = time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        li.append(total, text, when);
        historyList.appendChild(li);
      });
    };
    const pushHistory = (entry) => {
      const items = readHistory();
      items.unshift(entry);
      try { localStorage.setItem(HISTORY_KEY, JSON.stringify(items.slice(0, 25))); } catch (e) { /* ignore */ }
      renderHistory();
    };
    root.querySelector('[data-clear-history]').addEventListener('click', () => {
      try { localStorage.removeItem(HISTORY_KEY); } catch (e) { /* ignore */ }
      renderHistory();
    });
    renderHistory();

    /* ----- rolling ----- */
    const currentSpec = () => rows
      .map((r) => ({ sides: Number(r.dataset.die), count: Number(r.querySelector('[data-count]').value) || 0, color: r.dataset.color }))
      .filter((d) => d.count > 0);

    const describe = (spec) => spec.map((d) => `${d.count}d${d.sides}`).join(' + ');

    const doRoll = async () => {
      let spec = currentSpec();
      if (!spec.length) return;
      const mod = Number(modInput.value) || 0;
      resultBox.hidden = true;
      summaryEl.textContent = '';
      const DICE = await modulePromise.catch(() => null);
      if (DICE && DICE.clampSpec) {
        // the tray holds a limited number of physical dice; take them from
        // every type in turn and say when some stayed in the cup
        const clamped = DICE.clampSpec(spec);
        if (clamped.dropped > 0) {
          showToast(t('max_dice', 'The tray holds at most {{ max }} dice; {{ dropped }} stayed in the cup.').replace('{{ max }}', DICE.MAX_DICE).replace('{{ dropped }}', clamped.dropped));
        }
        spec = clamped.spec;
      }
      if (!engine) {
        // engine still loading or unavailable: plain random roll
        if (!DICE) { rollFallback(spec, mod); return; }
      }
      rolling = true;
      rollBtn.classList.add('is-rolling');
      rollLabel.textContent = t('rolling', 'Rolling…');
      let res = null;
      try {
        res = await engine.roll(spec, { mode: modeSel.value });
      } catch (e) {
        res = null;
      }
      if (res === null) return; // superseded by a newer roll
      rolling = false;
      rollBtn.classList.remove('is-rolling');
      rollLabel.textContent = rollLabel.dataset.label;
      showResult(res, spec, mod);
    };

    const rollFallback = (spec, mod) => {
      const res = { dice: [], total: 0, groups: {} };
      spec.forEach((d) => {
        for (let i = 0; i < d.count; i += 1) {
          const v = 1 + Math.floor(Math.random() * d.sides);
          res.dice.push({ sides: d.sides, kind: `d${d.sides}`, value: v, color: d.color });
          res.groups[`d${d.sides}`] = res.groups[`d${d.sides}`] || { sides: d.sides, values: [], sum: 0 };
          res.groups[`d${d.sides}`].values.push(v);
          res.groups[`d${d.sides}`].sum += v;
          res.total += v;
        }
      });
      showResult(res, spec, mod);
    };

    const showResult = (res, spec, mod) => {
      const total = res.total + mod;
      totalEl.textContent = String(total);
      const parts = Object.entries(res.groups).map(([kind, g]) => `${kind}: ${g.values.join(', ')}`);
      if (mod) parts.push(`${mod > 0 ? '+' : ''}${mod}`);
      breakdownEl.textContent = parts.join(' · ');
      resultBox.hidden = false;
      const nat = res.dice.length === 1 && res.dice[0].sides === 20 ? res.dice[0].value : null;
      let flavour = '';
      if (nat === 20) flavour = ` — ${t('nat20', 'Natural 20!')}`;
      if (nat === 1) flavour = ` — ${t('nat1', 'Natural 1…')}`;
      summaryEl.textContent = `${describe(spec)}${mod ? (mod > 0 ? ` + ${mod}` : ` − ${Math.abs(mod)}`) : ''} = ${total}${flavour}`;
      pushHistory({ total, text: `${describe(spec)}${mod ? (mod > 0 ? ` + ${mod}` : ` − ${Math.abs(mod)}`) : ''} · ${parts.join(' · ')}`, at: Date.now() });
    };

    rollBtn.addEventListener('click', doRoll);
    rollLabel.dataset.label = rollLabel.textContent;
    document.addEventListener('keydown', (e) => {
      if (e.key === ' ' && e.target === document.body) { e.preventDefault(); doRoll(); }
    });

    /* ----- boot the 3D engine ----- */
    const state = readState();
    if (state.dice) {
      rows.forEach((r) => {
        const s = state.dice[r.dataset.die];
        if (s) { r.querySelector('[data-count]').value = s.count; r.dataset.color = s.color || r.dataset.color; }
      });
    }
    if (typeof state.modifier === 'number') modInput.value = state.modifier;
    if (state.mode) modeSel.value = state.mode;
    root.dataset.tray = state.tray || root.dataset.defaultTray;
    updateRowState();

    const modulePromise = (async () => {
      const [THREE, CANNON, tex, DICE] = await Promise.all([
        loadThree(root.dataset.threeUrl),
        import(root.dataset.cannonUrl),
        import(root.dataset.texturesUrl),
        import(root.dataset.diceUrl),
      ]);
      TEX = tex;
      buildSwatches(TEX.DICE_COLORS);
      engine = DICE.createDiceScene({ THREE, CANNON, TEX, canvas, trayColor: root.dataset.tray });
      // tray colour picker
      const trayNames = { forest: 'Forest', burgundy: 'Burgundy', midnight: 'Midnight', charcoal: 'Charcoal', royal: 'Royal' };
      const trayHex = { forest: '#1c4e34', burgundy: '#5c1822', midnight: '#182244', charcoal: '#282a2e', royal: '#3a1a58' };
      engine.trayColors.forEach((key) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'games-swatch';
        b.style.background = trayHex[key];
        b.title = trayNames[key];
        b.setAttribute('aria-label', trayNames[key]);
        b.setAttribute('aria-pressed', String(root.dataset.tray === key));
        b.addEventListener('click', () => {
          root.dataset.tray = key;
          engine.setTrayColor(key);
          trayColorsBox.querySelectorAll('.games-swatch').forEach((s) => s.setAttribute('aria-pressed', 'false'));
          b.setAttribute('aria-pressed', 'true');
          writeState();
        });
        trayColorsBox.appendChild(b);
      });
      loading.hidden = true;
      return DICE;
    })();
    modulePromise.catch(() => {
      loading.hidden = true;
      fallback.hidden = false;
      buildSwatches([
        { key: 'crimson', label: 'Crimson', hex: '#a3202c' }, { key: 'forest', label: 'Forest', hex: '#1f5a3a' }, { key: 'sapphire', label: 'Sapphire', hex: '#1e3f8a' },
        { key: 'amethyst', label: 'Amethyst', hex: '#5b2a86' }, { key: 'obsidian', label: 'Obsidian', hex: '#17181c' }, { key: 'ivory', label: 'Ivory', hex: '#efe4c8' },
        { key: 'gold', label: 'Gold', hex: '#b8862b' }, { key: 'jade', label: 'Jade', hex: '#2d8a7a' },
      ]);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["games-hub"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-games-hub]');
    if (!root) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const loadThree = (url) => {
      if (window.THREE) return Promise.resolve(window.THREE);
      if (window.__threeLoadPromise) return window.__threeLoadPromise;
      window.__threeLoadPromise = import(url).then((m) => (m && m.Scene ? m : m.default));
      return window.__threeLoadPromise;
    };

    const isMobile = window.matchMedia('(max-width: 768px)').matches;

    const init = async () => {
      let THREE;
      let TEX;
      let DICE;
      try {
        [THREE, TEX, DICE] = await Promise.all([
          loadThree(root.dataset.threeUrl),
          import(root.dataset.texturesUrl),
          import(root.dataset.diceUrl),
        ]);
      } catch (e) {
        return; // static fallback stays visible
      }

      const banners = Array.from(root.querySelectorAll('.games-banner'));
      // Spread the CPU-heavy setup over frames instead of one long task right
      // after the bundle lands (4 procedural textures + 4 WebGL contexts + first
      // shader compile: ~150ms here, a second-long freeze on slower machines).
      const nextSlot = () => new Promise((resolve) => requestAnimationFrame(() => setTimeout(resolve, 0)));
      const shared = {};
      shared.felt = TEX.toTexture(THREE, TEX.felt({ size: 256 }), { repeat: 2 });
      await nextSlot();
      shared.leather = TEX.toTexture(THREE, TEX.leather({ size: 256 }), { repeat: 1 });
      await nextSlot();
      shared.wood = TEX.toTexture(THREE, TEX.wood({ size: 256 }), { repeat: 2 });
      await nextSlot();
      shared.parchment = TEX.toTexture(THREE, TEX.parchment({ size: 512, edge: 0.7 }), { repeat: 1 });
      await nextSlot();
      shared.glow = TEX.glowSprite(THREE, {});

      const makeRenderer = (canvas) => {
        const r = new THREE.WebGLRenderer({ canvas, antialias: !isMobile, alpha: true });
        r.setPixelRatio(Math.min(window.devicePixelRatio || 1, isMobile ? 1.5 : 2));
        r.shadowMap.enabled = !isMobile;
        r.shadowMap.type = THREE.PCFSoftShadowMap;
        r.toneMapping = THREE.ACESFilmicToneMapping;
        if (THREE.SRGBColorSpace) r.outputColorSpace = THREE.SRGBColorSpace;
        return r;
      };

      const baseLights = (scene) => {
        scene.add(new THREE.HemisphereLight(0xfff0d8, 0x1a0e08, 0.7));
        const key = new THREE.DirectionalLight(0xffe2bd, 2.4);
        key.position.set(-3, 6, 4);
        key.castShadow = !isMobile;
        key.shadow.mapSize.set(1024, 1024);
        key.shadow.camera.left = -6; key.shadow.camera.right = 6; key.shadow.camera.top = 6; key.shadow.camera.bottom = -6;
        scene.add(key);
        const rim = new THREE.PointLight(0xff8b00, 12, 20, 2);
        rim.position.set(4, 3, -3);
        scene.add(rim);
      };

      const embers = (scene, n, spread) => {
        const pos = new Float32Array(n * 3);
        for (let i = 0; i < n; i += 1) {
          pos[i * 3] = (Math.random() - 0.5) * spread;
          pos[i * 3 + 1] = Math.random() * 4;
          pos[i * 3 + 2] = (Math.random() - 0.5) * spread;
        }
        const g = new THREE.BufferGeometry();
        g.setAttribute('position', new THREE.BufferAttribute(pos, 3));
        const p = new THREE.Points(g, new THREE.PointsMaterial({ size: 0.16, map: shared.glow, transparent: true, depthWrite: false, blending: THREE.AdditiveBlending, opacity: 0.6 }));
        scene.add(p);
        return (dt) => {
          const a = p.geometry.attributes.position;
          for (let i = 0; i < a.count; i += 1) {
            let y = a.getY(i) + dt * 0.35;
            if (y > 4.2) y = 0;
            a.setY(i, y);
          }
          a.needsUpdate = true;
        };
      };

      /* ---------- Banner 1: tumbling dice on a felt tray ---------- */
      const diceScene = (canvas) => {
        const scene = new THREE.Scene();
        const camera = new THREE.PerspectiveCamera(38, 4 / 3, 0.1, 60);
        camera.position.set(0, 5.2, 6.4);
        camera.lookAt(0, 0.4, 0);
        baseLights(scene);
        const floor = new THREE.Mesh(new THREE.PlaneGeometry(12, 9), new THREE.MeshStandardMaterial({ map: shared.felt, roughness: 1 }));
        floor.rotation.x = -Math.PI / 2;
        floor.receiveShadow = true;
        scene.add(floor);
        const wallMat = new THREE.MeshStandardMaterial({ map: shared.leather, roughness: 0.85 });
        [[0, -4.5, 12.6, 0.6], [0, 4.5, 12.6, 0.6], [-6.3, 0, 0.6, 9.6], [6.3, 0, 0.6, 9.6]].forEach(([x, z, w, d]) => {
          const m = new THREE.Mesh(new THREE.BoxGeometry(w, 1.1, d), wallMat);
          m.position.set(x, 0.55, z);
          m.castShadow = true; m.receiveShadow = true;
          scene.add(m);
        });
        const specs = [[20, 'crimson', 0.85], [20, 'obsidian', 0.85], [12, 'sapphire', 0.8], [6, 'ivory', 0.7], [8, 'forest', 0.75], [10, 'gold', 0.78]];
        const dice = specs.map(([sides, color, size], i) => {
          const m = DICE.createDieMesh({ THREE, TEX, sides, colorKey: color, size });
          const a = (i / specs.length) * Math.PI * 2;
          m.userData = { a, r: 1.6 + (i % 2) * 1.1, phase: Math.random() * 6, spin: 0.4 + Math.random() * 0.6 };
          scene.add(m);
          return m;
        });
        const tickEmbers = embers(scene, 40, 10);
        let t = 0;
        return {
          scene, camera,
          tick(dt, hot) {
            t += dt * (hot ? 2.2 : 1);
            dice.forEach((m) => {
              const u = m.userData;
              const a = u.a + t * 0.18;
              m.position.set(Math.cos(a) * u.r, 0.55 + Math.abs(Math.sin(t * 1.6 + u.phase)) * 0.9, Math.sin(a) * u.r * 0.6);
              m.rotation.x += dt * u.spin * (hot ? 4 : 1.2);
              m.rotation.y += dt * u.spin * 0.8;
            });
            tickEmbers(dt);
          },
        };
      };

      /* ---------- Banner 2: floating character sheet & quill ---------- */
      const sheetCanvas = () => {
        const size = 512;
        const c = TEX.parchment({ size, edge: 0.5, stains: 3 });
        const ctx = c.getContext('2d');
        ctx.fillStyle = '#7a1f1f';
        ctx.font = `700 ${size * 0.075}px Cinzel, Georgia, serif`;
        ctx.textAlign = 'center';
        ctx.fillText('CHARACTER', size / 2, size * 0.13);
        ctx.strokeStyle = 'rgba(90,55,20,0.6)';
        ctx.lineWidth = 2;
        ctx.beginPath(); ctx.moveTo(size * 0.12, size * 0.17); ctx.lineTo(size * 0.88, size * 0.17); ctx.stroke();
        // stat circles
        const stats = ['STR', 'DEX', 'CON', 'INT', 'WIS', 'CHA'];
        stats.forEach((s, i) => {
          const x = size * 0.16;
          const y = size * 0.27 + i * size * 0.115;
          ctx.strokeStyle = 'rgba(90,55,20,0.75)';
          ctx.lineWidth = 3;
          ctx.beginPath(); ctx.arc(x, y, size * 0.045, 0, Math.PI * 2); ctx.stroke();
          ctx.fillStyle = '#2a1a10';
          ctx.font = `700 ${size * 0.03}px Cinzel, Georgia, serif`;
          ctx.fillText(s, x, y - size * 0.06);
          ctx.font = `700 ${size * 0.04}px Cinzel, Georgia, serif`;
          ctx.fillText(String(8 + Math.floor(Math.random() * 10)), x, y + size * 0.014);
        });
        // ruled lines
        ctx.strokeStyle = 'rgba(90,55,20,0.35)';
        ctx.lineWidth = 1.5;
        for (let i = 0; i < 12; i += 1) {
          const y = size * 0.27 + i * size * 0.055;
          ctx.beginPath(); ctx.moveTo(size * 0.3, y); ctx.lineTo(size * 0.88, y); ctx.stroke();
        }
        // shield
        ctx.strokeStyle = 'rgba(122,31,31,0.8)';
        ctx.lineWidth = 3;
        ctx.beginPath();
        ctx.moveTo(size * 0.72, size * 0.72); ctx.lineTo(size * 0.86, size * 0.76); ctx.lineTo(size * 0.84, size * 0.9); ctx.lineTo(size * 0.72, size * 0.97); ctx.lineTo(size * 0.6, size * 0.9); ctx.lineTo(size * 0.58, size * 0.76); ctx.closePath(); ctx.stroke();
        ctx.fillStyle = '#7a1f1f';
        ctx.font = `700 ${size * 0.06}px Cinzel, Georgia, serif`;
        ctx.fillText('17', size * 0.72, size * 0.865);
        return c;
      };

      const sheetScene = (canvas) => {
        const scene = new THREE.Scene();
        const camera = new THREE.PerspectiveCamera(36, 4 / 3, 0.1, 60);
        camera.position.set(0, 2.2, 6.2);
        camera.lookAt(0, 0.3, 0);
        baseLights(scene);
        const desk = new THREE.Mesh(new THREE.PlaneGeometry(16, 12), new THREE.MeshStandardMaterial({ map: shared.wood, roughness: 0.8 }));
        desk.rotation.x = -Math.PI / 2; desk.position.y = -1.6; desk.receiveShadow = true;
        scene.add(desk);
        const tex = new THREE.CanvasTexture(sheetCanvas());
        if (THREE.SRGBColorSpace) tex.colorSpace = THREE.SRGBColorSpace;
        const geo = new THREE.PlaneGeometry(3.1, 4.1, 24, 30);
        const sheet = new THREE.Mesh(geo, new THREE.MeshStandardMaterial({ map: tex, roughness: 0.9, side: THREE.DoubleSide }));
        sheet.castShadow = true;
        sheet.rotation.x = -0.35;
        scene.add(sheet);
        const base = geo.attributes.position.array.slice();
        // quill
        const quill = new THREE.Group();
        const shaft = new THREE.Mesh(new THREE.CylinderGeometry(0.02, 0.05, 2.2, 8), new THREE.MeshStandardMaterial({ color: 0xf1e6cf, roughness: 0.7 }));
        quill.add(shaft);
        const vane = new THREE.Mesh(new THREE.PlaneGeometry(0.5, 1.5), new THREE.MeshStandardMaterial({ color: 0xe8dcc2, side: THREE.DoubleSide, roughness: 0.8, transparent: true, opacity: 0.95 }));
        vane.position.set(0.18, 0.55, 0);
        quill.add(vane);
        const nib = new THREE.Mesh(new THREE.ConeGeometry(0.05, 0.3, 8), new THREE.MeshStandardMaterial({ color: 0xc9a24a, metalness: 0.9, roughness: 0.3 }));
        nib.position.y = -1.2; nib.rotation.x = Math.PI;
        quill.add(nib);
        quill.rotation.z = -0.55;
        quill.position.set(1.7, 0.9, 1.1);
        scene.add(quill);
        const d20 = DICE.createDieMesh({ THREE, TEX, sides: 20, colorKey: 'crimson', size: 0.6 });
        d20.position.set(-2.1, -0.6, 1.4);
        scene.add(d20);
        const tickEmbers = embers(scene, 30, 7);
        let t = 0;
        return {
          scene, camera,
          tick(dt, hot) {
            t += dt * (hot ? 1.8 : 1);
            const pos = geo.attributes.position;
            for (let i = 0; i < pos.count; i += 1) {
              const x = base[i * 3];
              const y = base[i * 3 + 1];
              pos.setZ(i, Math.sin(x * 1.6 + t * 1.4) * 0.09 + Math.cos(y * 1.2 + t) * 0.06);
            }
            pos.needsUpdate = true;
            geo.computeVertexNormals();
            sheet.position.y = 0.35 + Math.sin(t * 0.8) * 0.12;
            sheet.rotation.y = Math.sin(t * 0.35) * 0.18;
            quill.position.y = 0.9 + Math.sin(t * 1.3 + 1) * 0.15;
            quill.rotation.x = Math.sin(t * 0.9) * 0.15;
            d20.rotation.y += dt * 0.6;
            d20.rotation.x += dt * 0.25;
            tickEmbers(dt);
          },
        };
      };

      /* ---------- Banner 3: paint pots & palette ---------- */
      const paintScene = (canvas) => {
        const scene = new THREE.Scene();
        const camera = new THREE.PerspectiveCamera(38, 4 / 3, 0.1, 60);
        camera.position.set(0, 3.6, 6.2);
        camera.lookAt(0, 0.3, 0);
        baseLights(scene);
        const desk = new THREE.Mesh(new THREE.PlaneGeometry(16, 12), new THREE.MeshStandardMaterial({ map: shared.wood, roughness: 0.8 }));
        desk.rotation.x = -Math.PI / 2; desk.position.y = -0.5; desk.receiveShadow = true;
        scene.add(desk);
        const colors = [0xa52626, 0x1e3f8a, 0x2d8a7a, 0xc9a24a, 0x5b2a86, 0xefe4c8, 0x1f5a3a, 0xc9541b];
        const pots = colors.map((hex, i) => {
          const g = new THREE.Group();
          const body = new THREE.Mesh(new THREE.CylinderGeometry(0.42, 0.38, 0.9, 24), new THREE.MeshPhysicalMaterial({ color: hex, roughness: 0.25, transmission: 0.15, thickness: 0.4, clearcoat: 0.6 }));
          body.castShadow = true;
          g.add(body);
          const cap = new THREE.Mesh(new THREE.CylinderGeometry(0.44, 0.44, 0.2, 24), new THREE.MeshStandardMaterial({ color: 0x17181c, roughness: 0.5 }));
          cap.position.y = 0.55;
          g.add(cap);
          const label = new THREE.Mesh(new THREE.CylinderGeometry(0.425, 0.405, 0.35, 24, 1, true), new THREE.MeshStandardMaterial({ color: 0xf1e6cf, roughness: 0.8, side: THREE.DoubleSide }));
          label.position.y = -0.05;
          g.add(label);
          const a = (i / colors.length) * Math.PI * 2;
          g.userData = { a, r: 2.3, hex };
          scene.add(g);
          return g;
        });
        // palette
        const palette = new THREE.Group();
        const disc = new THREE.Mesh(new THREE.CylinderGeometry(1.15, 1.15, 0.08, 40), new THREE.MeshStandardMaterial({ map: shared.wood, roughness: 0.7 }));
        palette.add(disc);
        colors.slice(0, 6).forEach((hex, i) => {
          const blob = new THREE.Mesh(new THREE.SphereGeometry(0.2, 16, 12), new THREE.MeshStandardMaterial({ color: hex, roughness: 0.3 }));
          blob.scale.y = 0.35;
          const a = (i / 6) * Math.PI * 2;
          blob.position.set(Math.cos(a) * 0.7, 0.08, Math.sin(a) * 0.7);
          palette.add(blob);
        });
        palette.position.set(0, 0.05, 0.2);
        scene.add(palette);
        // brush
        const brush = new THREE.Group();
        const handle = new THREE.Mesh(new THREE.CylinderGeometry(0.05, 0.07, 2.4, 10), new THREE.MeshStandardMaterial({ color: 0x3b2418, roughness: 0.6 }));
        brush.add(handle);
        const ferrule = new THREE.Mesh(new THREE.CylinderGeometry(0.06, 0.05, 0.4, 10), new THREE.MeshStandardMaterial({ color: 0xc9a24a, metalness: 0.9, roughness: 0.3 }));
        ferrule.position.y = -1.35;
        brush.add(ferrule);
        const tip = new THREE.Mesh(new THREE.ConeGeometry(0.06, 0.35, 10), new THREE.MeshStandardMaterial({ color: 0xa52626, roughness: 0.6 }));
        tip.position.y = -1.7; tip.rotation.x = Math.PI;
        brush.add(tip);
        brush.rotation.z = 0.7;
        brush.position.set(-0.6, 1.6, 1.2);
        scene.add(brush);
        // drifting droplets
        const drops = colors.map((hex, i) => {
          const d = new THREE.Mesh(new THREE.SphereGeometry(0.09, 10, 8), new THREE.MeshStandardMaterial({ color: hex, roughness: 0.2, emissive: hex, emissiveIntensity: 0.25 }));
          d.userData = { a: Math.random() * 6, r: 1 + Math.random() * 1.8, h: 0.8 + Math.random() * 1.6, s: 0.3 + Math.random() * 0.5 };
          scene.add(d);
          return d;
        });
        let t = 0;
        return {
          scene, camera,
          tick(dt, hot) {
            t += dt * (hot ? 2 : 1);
            pots.forEach((g) => {
              const a = g.userData.a + t * 0.25;
              g.position.set(Math.cos(a) * g.userData.r, 0, Math.sin(a) * g.userData.r * 0.62);
            });
            palette.rotation.y = t * 0.3;
            brush.position.y = 1.6 + Math.sin(t * 1.4) * 0.15;
            brush.rotation.y = Math.sin(t * 0.6) * 0.3;
            drops.forEach((d) => {
              const u = d.userData;
              const a = u.a + t * u.s;
              d.position.set(Math.cos(a) * u.r, u.h + Math.sin(t * 1.1 + u.a) * 0.25, Math.sin(a) * u.r * 0.6);
            });
          },
        };
      };

      /* ---------- Banner 4: painting a grey miniature, stroke by stroke ---------- */
      const painterScene = (canvas) => {
        const scene = new THREE.Scene();
        const camera = new THREE.PerspectiveCamera(36, 4 / 3, 0.1, 60);
        camera.position.set(0, 2.4, 6.4);
        camera.lookAt(0, 1.2, 0);
        baseLights(scene);
        const desk = new THREE.Mesh(new THREE.PlaneGeometry(16, 12), new THREE.MeshStandardMaterial({ map: shared.wood, roughness: 0.8 }));
        desk.rotation.x = -Math.PI / 2; desk.receiveShadow = true;
        scene.add(desk);
        // the "photo": a grey knight silhouette drawn on a canvas, painted over time
        const size = 512;
        const pc = document.createElement('canvas');
        pc.width = size; pc.height = size;
        const pctx = pc.getContext('2d');
        const drawBase = () => {
          pctx.globalCompositeOperation = 'source-over';
          pctx.globalAlpha = 1;
          pctx.fillStyle = '#f4f1ea';
          pctx.fillRect(0, 0, size, size);
          const g = pctx.createLinearGradient(0, 0, size, size);
          g.addColorStop(0, '#9a9a9a'); g.addColorStop(1, '#5c5c5c');
          pctx.fillStyle = g;
          pctx.beginPath();
          pctx.ellipse(size * 0.5, size * 0.85, size * 0.22, size * 0.06, 0, 0, Math.PI * 2); pctx.fill();
          pctx.fillRect(size * 0.4, size * 0.5, size * 0.2, size * 0.35);
          pctx.beginPath(); pctx.ellipse(size * 0.5, size * 0.47, size * 0.17, size * 0.15, 0, 0, Math.PI * 2); pctx.fill();
          pctx.beginPath(); pctx.arc(size * 0.5, size * 0.24, size * 0.09, 0, Math.PI * 2); pctx.fill();
          pctx.beginPath(); pctx.ellipse(size * 0.26, size * 0.5, size * 0.07, size * 0.14, 0.2, 0, Math.PI * 2); pctx.fill();
          pctx.fillRect(size * 0.7, size * 0.18, size * 0.03, size * 0.45);
        };
        drawBase();
        const tex = new THREE.CanvasTexture(pc);
        if (THREE.SRGBColorSpace) tex.colorSpace = THREE.SRGBColorSpace;
        const frame = new THREE.Mesh(new THREE.BoxGeometry(3.6, 3.6, 0.12), new THREE.MeshStandardMaterial({ map: shared.leather, roughness: 0.8 }));
        frame.position.set(0, 1.9, -0.3); frame.castShadow = true;
        scene.add(frame);
        const pic = new THREE.Mesh(new THREE.PlaneGeometry(3.2, 3.2), new THREE.MeshStandardMaterial({ map: tex, roughness: 0.9 }));
        pic.position.set(0, 1.9, -0.23);
        scene.add(pic);
        const brush = new THREE.Group();
        brush.add(new THREE.Mesh(new THREE.CylinderGeometry(0.05, 0.07, 2.2, 10), new THREE.MeshStandardMaterial({ color: 0x3b2418, roughness: 0.6 })));
        const ferrule = new THREE.Mesh(new THREE.CylinderGeometry(0.06, 0.05, 0.4, 10), new THREE.MeshStandardMaterial({ color: 0xc9a24a, metalness: 0.9, roughness: 0.3 }));
        ferrule.position.y = -1.25; brush.add(ferrule);
        const tipMat = new THREE.MeshStandardMaterial({ color: 0xa52626, roughness: 0.6 });
        const tip = new THREE.Mesh(new THREE.ConeGeometry(0.06, 0.35, 10), tipMat);
        tip.position.y = -1.6; tip.rotation.x = Math.PI; brush.add(tip);
        brush.rotation.set(0.9, 0, -0.35);
        scene.add(brush);
        const cols = ['#a52626', '#1e3f8a', '#c9a24a', '#2d8a7a', '#efe4c8'];
        cols.forEach((hexc, i) => {
          const pot = new THREE.Mesh(new THREE.CylinderGeometry(0.28, 0.25, 0.6, 18), new THREE.MeshPhysicalMaterial({ color: hexc, roughness: 0.3, clearcoat: 0.6 }));
          pot.position.set(-2.3 + i * 0.75, 0.3, 1.4 + (i % 2) * 0.4);
          pot.castShadow = true;
          scene.add(pot);
        });
        const strokes = [
          { c: '#a52626', pts: [[0.36, 0.36], [0.62, 0.58]], r: 22 }, { c: '#a52626', pts: [[0.34, 0.5], [0.64, 0.42]], r: 20 },
          { c: '#1e3f8a', pts: [[0.42, 0.52], [0.58, 0.82]], r: 18 }, { c: '#c9a24a', pts: [[0.22, 0.4], [0.3, 0.62]], r: 16 },
          { c: '#efe4c8', pts: [[0.44, 0.2], [0.56, 0.28]], r: 14 }, { c: '#2d8a7a', pts: [[0.3, 0.84], [0.7, 0.86]], r: 16 },
          { c: '#cfcfd4', pts: [[0.71, 0.2], [0.72, 0.6]], r: 8 },
        ];
        let t = 0; let si = 0; let progress = 0;
        const tickEmbers = embers(scene, 20, 6);
        return {
          scene, camera,
          tick(dt, hot) {
            t += dt * (hot ? 2 : 1);
            progress += dt * (hot ? 1.2 : 0.55);
            const s = strokes[si % strokes.length];
            if (progress >= 1) {
              progress = 0; si += 1;
              if (si % strokes.length === 0) drawBase();
              tipMat.color.set(strokes[si % strokes.length].c);
            }
            const [a, b] = s.pts;
            const x = (a[0] + (b[0] - a[0]) * progress) * size;
            const y = (a[1] + (b[1] - a[1]) * progress) * size;
            pctx.globalCompositeOperation = 'multiply';
            pctx.globalAlpha = 0.5;
            pctx.fillStyle = s.c;
            pctx.beginPath(); pctx.arc(x + Math.sin(t * 9) * 3, y + Math.cos(t * 7) * 3, s.r, 0, Math.PI * 2); pctx.fill();
            pctx.globalCompositeOperation = 'source-over';
            pctx.globalAlpha = 1;
            tex.needsUpdate = true;
            brush.position.set(-1.6 + (x / size) * 3.2 + 0.25, 1.9 + (1.6 - (y / size) * 3.2) + 1.1, 0.35);
            brush.rotation.z = -0.35 + Math.sin(t * 3) * 0.08;
            tickEmbers(dt);
          },
        };
      };

      const builders = { dice: diceScene, sheet: sheetScene, paint: paintScene, painter: painterScene };
      const live = [];
      // Build at most one banner per animation frame (each = a WebGL context, a
      // scene and its first shader compile), and only once it is in view.
      const pending = [];
      let pumping = false;
      const pump = () => {
        if (pumping) return;
        pumping = true;
        const step = () => {
          const job = pending.shift();
          if (!job) { pumping = false; return; }
          job();
          requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      };
      banners.forEach((banner) => {
        const kind = banner.dataset.banner;
        const canvas = banner.querySelector('canvas');
        if (!canvas || !builders[kind]) return;
        let entry = null;
        let queued = false;
        let wantVisible = false;
        const ensure = () => {
          if (entry) return entry;
          try {
            const renderer = makeRenderer(canvas);
            const built = builders[kind](canvas);
            entry = { renderer, built, canvas, banner, visible: true, hot: false, last: performance.now() };
            const fit = () => {
              const w = canvas.clientWidth || 400;
              const h = canvas.clientHeight || 300;
              renderer.setSize(w, h, false);
              built.camera.aspect = w / h;
              built.camera.updateProjectionMatrix();
            };
            fit();
            new ResizeObserver(fit).observe(canvas);
            banner.addEventListener('pointerenter', () => { entry.hot = true; });
            banner.addEventListener('pointerleave', () => { entry.hot = false; });
            banner.classList.add('is-live');
            live.push(entry);
          } catch (e) {
            entry = null;
          }
          return entry;
        };
        const io = new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            wantVisible = e.isIntersecting;
            if (entry) { entry.visible = wantVisible; return; }
            if (!wantVisible || queued) return;
            queued = true;
            pending.push(() => { const en = ensure(); if (en) en.visible = wantVisible; });
            pump();
          });
        }, { threshold: 0.1 });
        io.observe(canvas);
      });

      const loop = (now) => {
        requestAnimationFrame(loop);
        if (document.hidden) return;
        live.forEach((en) => {
          if (!en.visible) return;
          const dt = Math.min((now - en.last) / 1000, 0.05);
          en.last = now;
          en.built.tick(dt, en.hot);
          en.renderer.render(en.built.scene, en.built.camera);
        });
      };
      requestAnimationFrame(loop);
    };

    if ('requestIdleCallback' in window) requestIdleCallback(init, { timeout: 1500 });
    else setTimeout(init, 200);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["games-paint-picker"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-games-pp]');
    if (!root) return;
    let i18n = {};
    try { i18n = JSON.parse(root.querySelector('[data-pp-i18n]').textContent); } catch (e) { i18n = {}; }
    import(root.dataset.appUrl)
      .then((m) => m.mount({
        root,
        i18n,
        money: root.dataset.moneyFormat,
        urls: { three: root.dataset.threeUrl, textures: root.dataset.texturesUrl, catalog: root.dataset.catalogUrl, index: root.dataset.indexUrl },
      }))
      .catch((err) => {
        const panel = root.querySelector('[data-pp-panel]');
        if (panel) panel.textContent = 'The paint picker could not start. ' + (err && err.message ? err.message : '');
        const loading = root.querySelector('[data-pp-loading]');
        if (loading) loading.hidden = true;
      });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["games-painter"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-games-mp]');
    if (!root) return;
    let i18n = {};
    try { i18n = JSON.parse(root.querySelector('[data-mp-i18n]').textContent); } catch (e) { i18n = {}; }
    import(root.dataset.appUrl)
      .then((m) => m.mount({ root, i18n, money: root.dataset.moneyFormat, urls: { catalog: root.dataset.catalogUrl, index: root.dataset.indexUrl } }))
      .catch((err) => {
        const el = root.querySelector('[data-mp-picker]');
        if (el) el.textContent = 'The painter could not start. ' + (err && err.message ? err.message : '');
      });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function() {
    function initVariantChips(card) {
      var chips = card.querySelectorAll('[data-variant-chip]');
      if (!chips.length) return;

      var imgEl = card.querySelector('.product-card__image');
      var formIdInput = card.querySelector('[data-variant-form-id]');

      chips.forEach(function(chip) {
        chip.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();

          // Deselect all, select this one
          chips.forEach(function(c) { c.classList.remove('variant-chip--selected'); });
          chip.classList.add('variant-chip--selected');

          // Swap image if variant has one
          var newImg = chip.getAttribute('data-variant-image');
          if (newImg && imgEl) {
            imgEl.style.opacity = '0.5';
            var tmp = new Image();
            tmp.onload = function() {
              imgEl.src = newImg;
              imgEl.removeAttribute('srcset');
              imgEl.style.opacity = '1';
            };
            tmp.src = newImg;
          }

          // Keep form variant id in sync (for single-variant "add to cart" path — not used when btn_is_link, but harmless)
          var variantId = chip.getAttribute('data-variant-id');
          if (formIdInput && variantId) {
            formIdInput.value = variantId;
          }
        });
      });
    }

    function initAllCards() {
      document.querySelectorAll('[data-product-card]').forEach(initVariantChips);
    }

    // Defer variant-chip wiring to idle time so it doesn't block first
    // interactivity on grids with many cards. Product links work without it.
    var deferCards = function () {
      if ('requestIdleCallback' in window) requestIdleCallback(initAllCards, { timeout: 1500 });
      else setTimeout(initAllCards, 300);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', deferCards);
    else deferCards();
    document.addEventListener('shopify:section:load', initAllCards);
  })();
  } catch(e) { console.error(e); }
})();

})();
